import React from 'react';
import StarRatings from 'react-star-ratings';
import './productCard.css';
import { useDispatch } from 'react-redux';
import { fetchProductById } from '../../features/product/productThunks';
import { Link } from 'react-router-dom';

export default function ProductCard({ product }) {

  return (
    <Link className="productCard-link" to={`/product-details/${product._id}`}>
    <div className="productCard-card">
      <div className="productCard-img-container">
        <img
          className="productCard-img"
          src={`https://shop-co-backend-stk3.onrender.com/upload/${product.mainImage}`}
          alt="product"
        />
      </div>
      <div className="productCard-details">
        <h3 className="productCard-name">{product.name}</h3>
        <div className="productCard-rating">
          <StarRatings
            rating={product.averageRating}
            starRatedColor="gold"
            numberOfStars={5}
            starDimension="20px"
            starSpacing="1px"
            name="rating"
          />
          <p className="productCard-averageRating">{product.averageRating}</p>
        </div>
        <div className="productCard-prices">
          <h4 className="productCard-price">{`$${product.priceAfterDiscount}`}</h4>
          <h4 className="productCard-price-discounted">{`$${product.price}`}</h4>
          <h5 className="productCard-discount">{`${product.discount}%`}</h5>
        </div>
      </div>
    </div>
    </Link>
  );
}
